module.exports = __webpack_public_path__ + "img/shops-icon.7f80ff29.svg";